/*
React nav component
*/

export default class ToTop extends React.Component {
  constructor(props) {
    super(props);

    this.style = {};

    this.state = {
      intervalId: 0
    };
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this),
  this.props.delayInMs);
    this.setState({ intervalId: intervalId});
  }

  render() {
    var content = (
      <div>
        <button id="to-top" className="btn btn-dark btn-lg" onClick={ () => {this.scrollToTop(); }}>
          <i className="fa fa-chevron-up fa-fw fa-1x"></i>
        </button>
      </div>
      );

      return content;
    }
  };



// WEBPACK FOOTER //
// src/js/view/component/toTop.jsx